/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPermissionsValidationError
 */
export interface UserPermissionsValidationError {
    /**
     * 
     * @type {string}
     * @memberof UserPermissionsValidationError
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPermissionsValidationError
     */
    message?: string | null;
}

export function UserPermissionsValidationErrorFromJSON(json: any): UserPermissionsValidationError {
    return UserPermissionsValidationErrorFromJSONTyped(json, false);
}

export function UserPermissionsValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': !exists(json, 'field') ? undefined : json['field'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UserPermissionsValidationErrorToJSON(value?: UserPermissionsValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'message': value.message,
    };
}


